import { Campaign } from "./campaign"
import { CampaignReport } from "./campaign_report"
import { PromotionCampaign } from "./promotion_campaign"

export class Promotion {
    constructor(promotion) {
        this.campaign           = new Campaign(promotion);
        this.campaign_report    = new CampaignReport(promotion.campaign_report);
        this.promotion_campaign = new PromotionCampaign(promotion.promotion_campaign);
    }
}